import { DEFAULT_EXPLORE_PAGE_SIZE } from "@/shared/constants";
import { useInfiniteQuery } from "@tanstack/react-query";
import { flatten } from "lodash";
import { useMemo } from "react";
import collectionsApi from "@/api/collections/client";

export function useCollections(marketplaces?: string[], searchTerm?: string) {
  const { data, isFetching, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: ["collections", marketplaces, searchTerm],
    queryFn: ({ pageParam = 0 }) =>
      collectionsApi.getCollections(
        DEFAULT_EXPLORE_PAGE_SIZE,
        pageParam * DEFAULT_EXPLORE_PAGE_SIZE,
        searchTerm,
        marketplaces,
      ),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < DEFAULT_EXPLORE_PAGE_SIZE) {
        return undefined;
      }
      return allPages.length;
    },
  });

  const collections = useMemo(() => {
    return data ? flatten(data.pages) : [];
  }, [data]);
  return { collections, isLoading: isFetching, hasNextPage, fetchNextPage };
}
